import { useMemo } from 'react';

import * as Recharts from 'recharts';
import Text from '../Text';

class Brush extends Recharts.Brush {
  static defaultProps = {
    ...Recharts.Brush.defaultProps,
    padding: { top: 1, right: 125, bottom: 1, left: 15 },
    alwaysShowText: true,
    height: 22,
    tickFormatter: (index) => {
      return index + 1;
    },
  };

  renderText() {
    const { startIndex, endIndex, y, height, travellerWidth, stroke } =
      this.props;
    const { startX, endX } = this.state;
    const offset = 5;
    const attrs = {
      pointerEvents: 'none',
      fill: stroke,
    };
    const yPos = y + height / 2 + 4;

    return (
      <Recharts.Layer className={'recharts-brush-texts'}>
        <Text
          textAnchor={'end'}
          verticalAnchor={'middle'}
          x={Math.min(startX, endX) - offset}
          y={yPos}
          {...attrs}
        >
          {this.getTextOfTick(startIndex)}
        </Text>
        <Text
          textAnchor={'start'}
          verticalAnchor={'middle'}
          x={Math.max(startX, endX) + travellerWidth + offset}
          y={yPos}
          {...attrs}
        >
          {this.getTextOfTick(endIndex)}
        </Text>
      </Recharts.Layer>
    );
  }
}

const BrushWithUpdateOnChangePosition = (props) => {
  const { forceId = '', updateId: _updateId } = props;
  // crate new data array to force brush recalculate position
  const updateId = useMemo(() => {
    return `${_updateId}-${forceId}`;
  }, [forceId, _updateId]);

  return <Brush {...props} updateId={updateId} />;
};
BrushWithUpdateOnChangePosition.defaultProps = {
  ...Brush.defaultProps,
};
BrushWithUpdateOnChangePosition.type = Brush.type;
BrushWithUpdateOnChangePosition.displayName = Brush.displayName;

export default BrushWithUpdateOnChangePosition;
